import { graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import React from "react"
import Layout from "src/components/Layout"
import LinkedButton from "src/components/buttons/LinkedButton"
import MemberCard from "src/components/cards/MemberCard"
import { TEAM_MEMBERS } from "src/data/team_data"
import * as styles from "src/styles/team.module.scss"

export default function Team({ data }) {
  const getImageData = imagePath => {
    return data.allFile.edges.find(
      element =>
        element.node.relativePath ===
        (imagePath ? imagePath : "team/default.png")
    )
  }

  const teamList = () =>
    TEAM_MEMBERS.map(member => (
      <MemberCard
        key={member.name}
        title={member.name}
        details={member.description}
        image={getImage(getImageData(member.image).node)}
      />
    ))

  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Meet Our Team</h1>
        <div className="card_grid">{teamList()}</div>
        <div className={styles.join_us}>
          <h2>Want to join with us?</h2>
          <LinkedButton path="/volunteer" label="Volunteer" />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query TeamImages {
    allFile(filter: { relativeDirectory: { eq: "team" } }) {
      edges {
        node {
          relativePath
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
